// src/features/auth/authSlice.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendOtp, verifyOtp } from '../http';

export const sendOtpThunk = createAsyncThunk(
  'auth/sendOtp',
  async (phoneNumber, { rejectWithValue }) => {
    try {
      return await sendOtp(phoneNumber);
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const verifyOtpThunk = createAsyncThunk(
  'auth/verifyOtp',
  async ({ phoneNumber, otp }, { rejectWithValue }) => {
    try {
      return await verifyOtp({ phoneNumber, otp });
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
